import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function PolicyLayout({ title, subtitle, lastUpdated, children, testId }) {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-[#0a0a0a]" data-testid={testId || "policy-page"}>
      <div className="container-tactical max-w-4xl">
        <Link to="/" className="inline-flex items-center gap-1 text-[#71717a] hover:text-[#C0A062] text-sm font-mono uppercase mb-8" data-testid="policy-back-home">
          <ChevronLeft className="w-4 h-4" /> Back to Home
        </Link>

        <div className="mb-10 pb-6 border-b border-white/5">
          <p className="font-mono text-[#C0A062] text-sm uppercase tracking-widest mb-2">
            {subtitle || "Policy"}
          </p>
          <h1 className="font-heading font-black text-4xl sm:text-5xl text-white uppercase tracking-tight" data-testid="policy-title">
            {title}
          </h1>
          {lastUpdated && (
            <p className="text-[#71717a] text-xs font-mono mt-4">Last updated: {lastUpdated}</p>
          )}
        </div>

        <div className="prose-policy text-[#D4D4D8] leading-relaxed space-y-8 text-[15px]">
          {children}
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 text-sm text-[#71717a]">
          Questions about this policy? Contact us at{" "}
          <a href="mailto:admin@resurrectedgunparts.com" className="text-[#C0A062] hover:underline">
            admin@resurrectedgunparts.com
          </a>{" "}or call (928) 637-8133.
        </div>
      </div>
    </div>
  );
}

export function PolicySection({ title, children }) {
  return (
    <section>
      <h2 className="font-heading font-bold text-white text-xl uppercase tracking-wide mb-3">
        {title}
      </h2>
      <div className="space-y-3 text-[#A1A1AA]">{children}</div>
    </section>
  );
}
